import React from 'react';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import { flowRight as compose } from 'lodash';
import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';
import FormControl from 'react-bootstrap/FormControl';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';

import CustomPagination from '../CustomPagination/CustomPagination';
import Loader from '../../components/Common/Loader';
import Link from '../Link/Link';

import messages from '../../locale/messages';
import debounce from '../../helpers/debounce';
import deleteTopFeature from '../../actions/siteadmin/TopFeature/deleteTopFeature';
import updateTopFeatureStatus from '../../actions/siteadmin/TopFeature/updateTopFeatureStatus';
import getCurrentPage from '../../helpers/getCurrentPage';
import { demoRestriction } from '../../actions/demoRestriction';

import getAllHomePageCategorySettings from '../../routes/site-admin/categorySettings/getAllHomePageCategorySettings.graphql';
import { withQuery } from '../../hoc/withGraphql';
import { CommonAdminEditIcon, CommonAdminTrashIcon } from '../Common/Assets/SVGIcon/CommonSvgIcon';


import bt from '../../components/commonStyle.css';
import s from './TopFeatureList.css';

class TopFeatureList extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            currentPage: 1,
            searchList: '',
        }
    }

    handleKeywordSearch = debounce((searchList) => {
        const { getAllHomePageCategorySettings: { refetch } } = this.props;
        let variables = {
            currentPage: 1,
            searchList: searchList
        }
        this.setState({ searchList, currentPage: 1 });
        refetch(variables);
    });

    paginationData = (currentPage) => {
        const { getAllHomePageCategorySettings: { refetch } } = this.props;
        let variables = { currentPage };
        this.setState({ currentPage });
        refetch(variables);
    }

    handleDelete = async (id, currentPage) => {
        const { deleteTopFeature, getAllHomePageCategorySettings: { refetch, getAllHomePageCategorySettings }, demoRestriction } = this.props;
        currentPage = await getCurrentPage({ results: getAllHomePageCategorySettings?.results, page: currentPage });
        let variables = { currentPage };
        const isRestrict = await demoRestriction({});
        if (isRestrict) return;
        const response = await deleteTopFeature(id);
        if (response?.status == 200) {
            this.setState({ currentPage });
            refetch(variables);
        }
    }

    handleStatus = async (id, isActive, currentPage) => {
        const { updateTopFeatureStatus, getAllHomePageCategorySettings: { refetch }, demoRestriction } = this.props;
        let variables = { currentPage };
        const isRestrict = await demoRestriction({});
        if (isRestrict) return;
        await updateTopFeatureStatus(id, isActive);
        refetch(variables);
    }

    render() {
        const { formatMessage } = this.props.intl;
        const { getAllHomePageCategorySettings, getAllHomePageCategorySettings: { loading } } = this.props;
        const { currentPage } = this.state;

        return (
            <div className={'whiteDropdown'}>
                <div className={s.exportDisplay}>
                    <div className={s.searchGroupContainer}>
                        <div className={cx(s.searchInput, 'searchInputRTL')}>
                            <FormControl type='text' placeholder={formatMessage(messages.searchOnly)} onChange={(event) => this.handleKeywordSearch(event.target && event.target.value)} className={bt.formControlInput} />
                        </div>
                    </div>
                    <div className={cx(s.exportTextSection)}>
                        <Link to={`/siteadmin/homepage/top-feature/add`} className={cx(bt.btnPrimary, s.displayInlineBlock)} >{formatMessage(messages.addNewLabel)}</Link>
                    </div>
                </div>
                {
                    loading && <div>
                        <Loader type="circle" />
                    </div>
                }
                {!loading &&
                    <div className='tableOuterContainer'>
                        <Table className="tableContainer">
                            <thead>
                                <tr>
                                    <th scope="col"><FormattedMessage {...messages.id} /></th>
                                    <th scope="col"><FormattedMessage {...messages.name} /></th>
                                    <th scope="col"><FormattedMessage {...messages.status} /></th>
                                    <th scope="col"><FormattedMessage {...messages.action} /></th>
                                    <th scope="col"><FormattedMessage {...messages.deleteAction} /></th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    getAllHomePageCategorySettings?.getAllHomePageCategorySettings?.results?.map((item, index) => {
                                        return (
                                            <tr key={index}>
                                                <td data-label={formatMessage(messages.id)}>{item?.id}</td>
                                                <td data-label={formatMessage(messages.name)}>{item?.title}</td>
                                                <td data-label={formatMessage(messages.status)}>
                                                    <div>
                                                        <select className={bt.selectInput} value={item?.isActive} onChange={(e) => { this.handleStatus(item?.id, e?.target?.value, currentPage) }}>
                                                            <option value={1}>{formatMessage(messages.active)}</option>
                                                            <option value={0}>{formatMessage(messages.inactive)}</option>
                                                        </select>
                                                    </div>
                                                </td>
                                                <td data-label={formatMessage(messages.action)}>
                                                    <div>
                                                        <Link to={'/siteadmin/homepage/top-feature/edit/' + item.id} className={s.noLink}>
                                                            <CommonAdminEditIcon className={cx(s.editIcon, 'editIconRTL')} />
                                                            <span className={s.vtrMiddle}>
                                                                <FormattedMessage {...messages.editAction} />
                                                            </span>
                                                        </Link>
                                                    </div>
                                                </td>
                                                <td data-label={formatMessage(messages.deleteAction)}>
                                                    <div>
                                                        <Button onClick={() => this.handleDelete(item.id, currentPage)} className={s.iconBtn}>
                                                            <CommonAdminTrashIcon className={cx(s.editIcon, 'editIconRTL')} />
                                                            <span className={s.vtrMiddle}><FormattedMessage {...messages.deleteAction} /></span>
                                                        </Button>
                                                    </div>
                                                </td>
                                            </tr>
                                        )
                                    })}

                                {
                                    !loading && getAllHomePageCategorySettings?.getAllHomePageCategorySettings?.results.length == 0 && (
                                        <tr>
                                            <td colspan="12" className={'tableNoRecordCel'}><FormattedMessage {...messages.noResult} /></td>
                                        </tr>
                                    )
                                }
                            </tbody>
                        </Table>
                    </div>
                }
                {
                    getAllHomePageCategorySettings?.getAllHomePageCategorySettings?.results?.length > 0
                    && <div className={cx(bt.space5, bt.spaceTop5)}>
                        <CustomPagination
                            total={getAllHomePageCategorySettings?.getAllHomePageCategorySettings?.count}
                            currentPage={currentPage}
                            defaultCurrent={1}
                            defaultPageSize={10}
                            change={this.paginationData}
                            paginationLabel={formatMessage(messages.categorieslist)}
                        />
                    </div>
                }
            </div>
        )
    }
}

const mapDispatch = {
    deleteTopFeature,
    updateTopFeatureStatus,
    demoRestriction
};
const mapState = (state) => ({});

export default injectIntl(compose(
    withStyles(bt, s),
    withQuery(getAllHomePageCategorySettings, {
        name: 'getAllHomePageCategorySettings',
        options: {
            variables: {
                currentPage: 1,
                searchList: ''
            },
            fetchPolicy: 'network-only',
            ssr: false
        }
    }),
    connect(mapState, mapDispatch)
)(TopFeatureList))